import React from "react";
import ParrotText from "../components/ParrotText";
import ContinueButton from "../components/Buttons/ContinueButton";
import TitleBox from "../components/TitleBox";
import { useNavigate } from "react-router-dom";

const ErrorPage: React.FC = () => {
  const navigate = useNavigate();
  const handleGoHome = () => {
    navigate("/home/learn");
  };

  return (
    <div className="appPadding flex flex-col h-full w-full overflow-hidden items-center justify-between">
      <div className="w-full pt-12">
        <ParrotText />
      </div>
      <div className="w-full flex flex-grow justify-center">
        <TitleBox
          title={
            <span className="text-center items-center justify-center">
              <p>Oops, something went wrong</p>
              <p>😢</p>
            </span>
          }
          subtitle={
            <span className="text-center items-center justify-center">
              We're sorry we couldn't process your request. Please try again
              later or contact support@fluentwithparrot.com.
            </span>
          }
          classname="text-center items-center justify-center"
        />
      </div>
      <div className="w-full pb-6">
        <ContinueButton onClick={handleGoHome} text="Go Back Home" />
      </div>
    </div>
  );
};

export default ErrorPage;
